/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Extrai campos de configuração do node
 */
export const extractFields = (settings: any): any[] => {
  if (!settings) return [];
  
  const fields: any[] = [];

  // Verificar se temos uma estrutura de workflowConfig (nova estrutura da API)
  if (settings.workflowConfig) {
    // Converter o workflowConfig em campos de formulário
    Object.entries(settings.workflowConfig).forEach(([key, value]: [string, any]) => {
      if (key !== 'title') { // Excluir o título, já que ele é tratado separadamente
        // IMPORTANTE: Copiar TODOS os campos, não apenas type e default
        // Isso preserva options, label, description, placeholder, visibilityConditions, etc.
        fields.push({
          name: key,
          ...value, // Copiar todos os campos do valor
          // Garantir que temos pelo menos um label
          label: value.label || key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' '),
          // Usar value.default se existir, senão value.value, senão ''
          default: value.default !== undefined ? value.default : (value.value || '')
        });
      }
    });
    return fields;
  }
  
  // Processar campos diretos (estrutura antiga)
  if (Array.isArray(settings.fields)) {
    fields.push(...settings.fields);
  }

  // Processar campos de input
  if (settings.input?.fields) {
    fields.push(...settings.input.fields);
  }

  // Processar campos de output
  if (settings.output?.fields) {
    fields.push(...settings.output.fields);
  }

  return fields;
};
